<template>
  <v-list-item-content
    :class="[{'px-2':panelView},hover&&panelView?'white clickable':'','my-2', width]"
    @mouseover="hover=true"
    @mouseleave="hover=false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <h4 class="text--grey text--darken-1">{{item.medical_code}}</h4>
    <v-row>
      <v-col cols="10" class="pb-0">
        <v-list-item-content :class="width">
          <span>{{ item.description }}</span>
        </v-list-item-content>
      </v-col>
      <v-col cols="2">
        <v-btn
          @click.stop="updateFavorites"
          dense
          icon
        >
          <v-icon
            large
            @click.stop="updateFavorites"
            :color="isStarred ?'yellow darken-2':'grey'"
          >
            mdi-star
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-list-item-content>
</template>

<script>
  export default {
    name: 'DiagnosisItem',

    props: {
      item: { type: Object },
      panelView: { type: Boolean, default: false },
      width: { type: String, default: 'width500' }
    },

    data: () => ({
      starred: null,
      hover: false
    }),

    computed: {
      isStarred() {
        if (this.favoriteCodes && this.favoriteCodes.length > 0) {
          var found = this.favoriteCodes.findIndex(item => item.id == this.item.id)
          return found >= 0 ? true : false
        }
        else {
          return false
        }
      },
      favoriteCodes() {
        return this.$store.getters['diagnosis/fave_codes']
      },
      mostUsedCodes() {
        var codes = this.$store.getters['diagnosis/used_codes']
        var sortedCodes = codes.sort((a,b) => a.uses - b.uses)
        return sortedCodes
      }
    },

    mounted() {
      this.starred = this.isStarred
    },

    methods: {
      async updateFavorites() {
        this.$store.dispatch('diagnosis/updateFavorites', this.item)
        this.starred = !this.starred
      }
    }
  }
</script>

<style lang="scss" scoped>
.med {
  font-size: 13px !important;

  .head-text {
    font-size: 15px;
  }
}

.width500 {
  max-width: 500px;
}

.widthInherit {
  max-width: inherit;
}
</style>